export default {
  // Common
  nav: {
    home: "Home",
    features: "Features",
    pricing: "Pricing",
    about: "About",
    contact: "Contact",
    demo: "Request Demo",
    blog: "Blog",
    login: "Login"
  },

  // Plan Calculator
  planCalculator: {
    label: "PLAN CALCULATOR",
    question: "Roughly how many calls do you receive each month?",
    estimatesFor: "Estimates for {count} calls per month",
    dailyCalls: "Daily calls",
    dailyCallsDesc: "Typical usage pattern",
    monthlyMinutes: "Monthly minutes",
    monthlyMinutesDesc: "Most calls last 2-3 minutes",
    recommendedPlan: "Recommended plan",
    bestValue: "Your best-value option",
    recommendedLabel: "Recommended Plan",
    includedMinutes: "included minutes per month",
    perMinAfter: "/min after",
    claimTrial: "Claim Free Trial",
    features: "FEATURES"
  },
  
  // Home page
  hero: {
    title: "Never Miss a",
    rotatingWords: [
      { word: "Booking Again", article: "" },
      { word: "Call Again", article: "" },
      { word: "Guest Again", article: "" },
      { word: "Sale Again", article: "" }
    ],
    subtitle: {
      part1: "Every unanswered call is lost revenue. HostCall.ai handles unlimited guest calls ",
      highlight: "24/7",
      part2: " in 20+ languages—turning inquiries into bookings while you sleep."
    },
    cta: "See How It Works",
    demo: "Start Capturing More Bookings",
    multilingual: "Now with multilingual support for 20+ languages",
    platformBadge: "HostCall AI Sales & Service Platform",
    floatingCards: {
      incomingCall: "Incoming Call",
      callerPhone: "+1 (555) 123-4567",
      detectedIntent: "Detected Intent",
      verifyBooking: "Verify Booking",
      sendDoorCode: "Send Door Code",
      assistantMessage: "I've verified your booking and sent the door code to your phone. Welcome to your stay!",
      justNow: "Just now"
    },
    stats: {
      calls: "50,000+",
      callsLabel: "Calls Handled",
      properties: "200+",
      propertiesLabel: "Properties",
      satisfaction: "4.9/5",
      satisfactionLabel: "Satisfaction",
      hoursSaved: "Hours Saved Weekly",
      moreBookings: "More Bookings",
      guestSupport: "Guest Support",
      guestSatisfaction: "Guest Satisfaction"
    },
    heroImageAlt: "Guest arriving at luxury apartment"
  },

  // Meeting Booking
  meetingBooking: {
    title: "Book a Meeting",
    subtitle: "Schedule a time with our team to learn more about hostcall.ai.",
    thankYou: "Thank You!",
    thankYouMessage: "Your meeting request has been sent. We'll get back to you shortly.",
    scheduleTitle: "Schedule your meeting",
    labels: {
      name: "Name",
      namePlaceholder: "Your name",
      email: "Work Email",
      emailPlaceholder: "you@company.com",
      date: "Preferred Date",
      time: "Preferred Time",
      timePlaceholder: "Select a time",
      notes: "Additional Notes",
      notesPlaceholder: "Tell us anything that will help us prepare"
    },
    submitting: "Submitting...",
    submit: "Book Meeting",
    toast: {
      title: "Meeting Requested",
      description: "We will contact you soon to confirm your meeting.",
      errorTitle: "Error",
      errorDescription: "There was a problem submitting your request. Please try again."
    }
  },

  // Testimonials section
  testimonials: {
    title: "Trusted by Hospitality Leaders",
    subtitle: "See why property managers and hoteliers around the world rely on hostcall.ai to enhance their guest communication.",
    trustedBy: "TRUSTED BY",
    testimonial1: {
      quote: "hostcall.ai has completely transformed our guest communication process. We've seen a 35% increase in guest satisfaction scores and saved countless hours on routine calls.",
      author: "Jacob Granberg",
      role: "Head of Sales",
      company: "Guestly Homes",
      imageAlt: "Jacob Granberg profile photo"
    },
    testimonial2: {
      quote: "The multilingual support is a game-changer for our international clientele. Our guests love getting immediate answers in their own language at any time of day.",
      author: "Michael Rodriguez",
      role: "Front Office Director",
      company: "Seaside Luxury Resort",
      imageAlt: "Michael Rodriguez profile photo"
    },
    testimonial3: {
      quote: "We were skeptical about using AI for guest communication, but hostcall.ai sounds remarkably natural. The personalization options allow us to maintain our brand voice consistently.",
      author: "Emma Thompson",
      role: "Guest Experience Manager",
      company: "Mountain View Lodge",
      imageAlt: "Emma Thompson profile photo"
    },
    testimonial4: {
      quote: "Since implementing hostcall.ai, we've been able to handle 300% more guest inquiries without increasing our staff. It's been a total game-changer for our boutique hotel.",
      author: "David Chen",
      role: "Property Manager",
      company: "Urban Loft Stays",
      imageAlt: "David Chen profile photo"
    }
  },

  // Image alt texts
  imageAlts: {
    featureVisualization: "Feature visualization for"
  },

  // Use Case Showcase
  useCaseShowcase: {
    title: "Experience hostcall.ai in Action",
    subtitle: "Explore real-world demos of how our AI voice technology transforms guest experiences across different hospitality settings."
  },

  // Customer Experience Ownership
  customerExperience: {
    title: "Take Complete Ownership of Your Customer Experience",
    subtitle: "hostcall.ai delivers complete infrastructure that frees your customer experience from dependency on major AI providers. Enjoy lightning-fast responses, guaranteed 99.99% uptime, and minimal third-party reliance—all while reducing your per-call costs to virtually nothing.",
    features: {
      fullyOwnedData: {
        title: "Fully Owned Data",
        description: "Your customer data stays within your infrastructure. Process everything in-house with no third-party exposure."
      },
      soc2Certified: {
        title: "SOC2 Type II Certified",
        description: "Enterprise-grade security with independent SOC2 Type II certification, meeting the highest industry standards."
      },
      gdprCompliant: {
        title: "GDPR Compliant Systems",
        description: "Built-in GDPR compliance for European customer privacy rights, enabling seamless global operations."
      },
      hipaaReady: {
        title: "HIPAA Ready Security",
        description: "Healthcare-grade protection with HIPAA-compliant systems safeguarding sensitive data across all touchpoints."
      },
      penetrationTesting: {
        title: "Continuous Penetration Testing",
        description: "Proactive security through regular testing by ethical hackers to identify and patch vulnerabilities early."
      },
      qualityAssurance: {
        title: "Comprehensive Quality Assurance",
        description: "Automated and manual testing to verify system integrity, ensuring security and flawless experiences."
      },
      whiteGlove: {
        title: "White-Glove Implementation",
        description: "Expert-led setup by security professionals who tailor systems to your requirements while eliminating vulnerabilities."
      },
      enterpriseGuardrails: {
        title: "Enterprise Guardrails",
        description: "Advanced security boundaries built into every system layer, preventing unauthorized access and ensuring integrity."
      }
    }
  },

  // Footer
  footer: {
    product: "Product",
    company: "Company",
    resources: "Resources",
    legal: "Legal",
    copyright: "© 2025 hostcall.ai. All rights reserved.",
    description: "The AI-powered virtual team member that handles calls, messages, and requests 24/7.",
    links: {
      features: "Features",
      integrations: "Integrations",
      pricing: "Pricing",
      faq: "FAQ",
      about: "About",
      blog: "Blog",
      careers: "Careers",
      contact: "Contact",
      apiDocs: "API Documentation",
      helpCenter: "Help Center",
      support: "Support",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      cookies: "Cookies Policy"
    }
  },

  // About Page
  about: {
    hero: {
      title: "Our Mission is to Transform Hospitality Communication",
      subtitle: "At hostcall.ai, we're combining cutting-edge AI technology with deep hospitality expertise to create exceptional guest experiences.",
      imageAlt: "Nordic landscape with mountains and fjords"
    },
    story: {
      title: "Our Story",
      paragraph1: "hostcall.ai was born from a simple observation: hotels and vacation rentals spend countless hours on repetitive guest communication, taking valuable time away from creating exceptional in-person experiences.",
      paragraph2: "Our founder, Joakim Thörn, experienced this challenge firsthand while managing luxury properties. He noticed that staff were constantly fielding the same questions about check-in times, amenities, and local recommendations—often playing phone tag with guests or missing opportunities to enhance their stay.",
      paragraph3: "In 2024, Joakim had the idea and began assembling a team of AI experts and hospitality veterans with a bold mission: create an AI communication platform specifically designed for the unique needs of hospitality businesses. Throughout 2025, the team focused on intensive research and development, building the first prototype of the platform.",
      paragraph4: "In early 2026, we launched our beta with select boutique hotels and vacation rental properties, refining our AI based on real-world feedback. Our official public launch is planned for Q2 2026, and we're excited to continue expanding our platform with new features and integrations to transform hospitality communication worldwide."
    },
    values: {
      title: "Our Core Values",
      subtitle: "These principles guide everything we do at hostcall.ai",
      value1: {
        title: "Guest-First Approach",
        description: "We design every feature and interaction with the guest experience as our top priority. Technology should enhance, not replace, human connection."
      },
      value2: {
        title: "Continuous Learning",
        description: "Our AI is constantly improving through real-world interactions, becoming more helpful and natural with each conversation."
      },
      value3: {
        title: "Hospitality Expertise",
        description: "We combine technological innovation with deep industry knowledge to solve real challenges faced by hospitality providers."
      }
    },
    team: {
      title: "Meet Our Team",
      subtitle: "The passionate experts behind hostcall.ai",
      members: {
        joakim: {
          role: "CEO & Founder",
          bio: "Hospitality executive with 25+ years of experience in customer experience. Founded hostcall.ai to solve the guest communication challenges he experienced firsthand."
        },
        maria: {
          role: "Chief Technology Officer",
          bio: "AI and ML expert with a PhD in Natural Language Processing. Led AI development teams at major tech companies before joining hostcall.ai."
        },
        david: {
          role: "Head of Hospitality",
          bio: "Spent 20 years managing properties for major hotel chains across the globe. Expert in guest experience optimization and operational excellence."
        },
        sarah: {
          role: "Head of Customer Success",
          bio: "Dedicated to ensuring hostcall.ai delivers exceptional results for every client. Previously led customer experience teams in SaaS and hospitality."
        }
      }
    },
    journey: {
      title: "Our Journey",
      subtitle: "The evolution of hostcall.ai from concept to industry leader",
      timeline: {
        idea: {
          title: "The Idea",
          description: "hostcall.ai was conceived after founder Joakim Thörn experienced the challenges of managing guest communication at scale."
        },
        research: {
          title: "Research & Development",
          description: "Assembled a team of AI experts and hospitality veterans to build the first prototype of the hostcall.ai platform."
        },
        beta: {
          title: "Beta Launch",
          description: "Launched our beta with select boutique hotels and vacation rental properties, refining our AI based on real-world feedback."
        },
        launch: {
          title: "Official Launch",
          description: "hostcall.ai officially launches to the public, offering a complete guest communication solution for properties of all sizes."
        },
        future: {
          title: "Looking Ahead",
          description: "Expanding our platform with new features and integrations to further transform hospitality communication worldwide."
        }
      }
    },
    join: {
      title: "Join Us on Our Mission",
      subtitle: "Partner with hostcall.ai to transform your guest communication and be part of the future of hospitality.",
      demo: "Request Demo",
      careers: "Join Our Team"
    }
  },

  // Business Cases
  businessCases: {
    hero: {
      title: "Real Success Stories from the Hospitality Industry",
      subtitle: "Discover how hotels and vacation rental businesses are transforming their guest communication and operations with hostcall.ai",
      demo: "Schedule a Demo",
      pricing: "View Pricing"
    },
    breakdown: "Business Case Breakdown",
    challenge: "THE CHALLENGE",
    solution: "THE SOLUTION",
    outcome: "THE OUTCOME"
  },

  // Features and Home page sections
  features: {
    title: "Comprehensive Guest Communication",
    subtitle: "hostcall.ai handles every aspect of guest communication throughout their journey, from booking to checkout and beyond.",
    callHandling: "24/7 Call Handling",
    preStay: "Pre-Stay Communication",
    inStay: "In-Stay Support",
    postStay: "Post-Stay Follow-up",
    multilingual: "Multi-language Support",
    integration: "Seamless Integration",
    featureCard1: {
      title: "24/7 Guest Communication",
      description: "Never miss a guest message with around-the-clock AI assistance."
    },
    featureCard2: {
      title: "Multilingual Support",
      description: "Communicate with guests in over 20 languages with perfect accuracy."
    },
    featureCard3: {
      title: "Sales on autopilot",
      description: "Easily connects with your existing PMS and hospitality management systems."
    },
    featureCard4: {
      title: "Detailed Analytics",
      description: "Track performance metrics and improve your guest satisfaction scores."
    }
  },
  
  howItWorks: {
    title: "How hostcall.ai Works",
    subtitle: "Our platform seamlessly integrates with your existing hospitality systems to provide automated, intelligent guest communication.",
    steps: {
      step1: {
        title: "Easy Integration",
        desc: "Connect hostcall.ai to your existing systems with our simple API or pre-built integrations. Setup takes minutes, not days."
      },
      step2: {
        title: "Customize Your AI",
        desc: "Train the AI on your property's specific details, policies, and local information to deliver accurate guest assistance."
      },
      step3: {
        title: "Automate Communications",
        desc: "Let hostcall.ai handle routine calls and inquiries while your team focuses on delivering exceptional in-person experiences."
      },
      step4: {
        title: "Monitor & Optimize",
        desc: "Access detailed analytics and conversation transcripts to continuously improve your guest communication strategy."
      }
    },
    cta: {
      title: "Ready to transform your guest communications?",
      subtitle: "Join leading properties already using hostcall.ai to enhance guest satisfaction and operational efficiency.",
      button: "Get Started Now"
    }
  },

  // Contact page
  contact: {
    title: "Get in Touch",
    subtitle: "We'd love to hear from you. Our team is standing by to answer your questions.",
    email: "Email",
    phone: "Phone",
    office: "Office",
    hero: {
      title: "Get in Touch",
      subtitle: "Have questions or ready to transform your guest communication? Our team is here to help you implement the perfect solution for your property.",
      callUs: {
        title: "Call Us",
        description: "Speak directly with our team"
      },
      emailUs: {
        title: "Email Us",
        description: "We'll respond within 24 hours"
      },
      liveChat: {
        title: "Live Chat",
        description: "Chat with our support team",
        button: "Start Chat"
      }
    },
    form: {
      title: "Contact Information",
      subtitle: "Fill out the form and our team will get back to you as soon as possible.",
      name: "Name",
      email: "Email",
      message: "Message",
      submit: "Send Message",
      office: "Our Office",
      phone: "Phone",
      emailLabel: "Email",
      followUs: "Follow Us",
      sendMessage: "Send a Message"
    },
    map: {
      title: "Our Location",
      headquarters: "Hostcall.ai Headquarters",
      apiKeyPrompt: "Please enter your Google Maps API key to display the map",
      saveKey: "Save Key",
      apiKeyNote: "Your API key will be stored locally and is not sent to our servers.",
      loadError: "Error loading Google Maps",
      changeApiKey: "Change API key",
      loading: "Loading Maps..."
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Find quick answers to common questions about hostcall.ai",
      question1: {
        q: "How quickly can we implement hostcall.ai?",
        a: "Most properties are up and running within 1-2 weeks, with basic implementations possible in as little as 48 hours."
      },
      question2: {
        q: "Which property management systems do you integrate with?",
        a: "We support all major PMS platforms including Opera, Mews, Cloudbeds, and many others. Custom integrations are available for Enterprise clients."
      },
      question3: {
        q: "Do you offer 24/7 support?",
        a: "Yes, all paid plans include access to our support team, with Enterprise clients receiving dedicated 24/7 technical support."
      },
      question4: {
        q: "Can hostcall.ai handle multiple properties?",
        a: "Absolutely. Our platform is designed to scale from single properties to large hotel groups with custom management dashboards."
      }
    }
  },

  // Careers page
  careers: {
    hero: {
      titlePart1: "Join Our",
      titleHighlight: "Team",
      subtitle: "Help us transform the hospitality industry with cutting-edge AI technology. We're looking for passionate individuals to join our fully remote team.",
      viewPositions: "View Open Positions"
    },
    listings: {
      title: "Open Positions",
      subtitle: "Explore our current job openings and find a role that matches your skills and passion.",
      applyNow: "Apply Now"
    },
    form: {
      title: "Apply Now",
      subtitle: "Fill out the form below to apply for one of our open positions. We look forward to learning more about you!",
      labels: {
        fullName: "Full Name",
        email: "Email",
        phone: "Phone",
        position: "Position",
        linkedin: "LinkedIn Profile",
        portfolio: "Portfolio / Website",
        coverLetter: "Why are you interested in this position?"
      },
      placeholders: {
        fullName: "Your full name",
        email: "your@email.com",
        phone: "Your phone number",
        position: "Select a position to apply for",
        linkedin: "https://linkedin.com/in/your-profile",
        portfolio: "https://your-website.com",
        coverLetter: "Tell us why you're interested in joining our team and what you can bring to the role..."
      },
      optional: "Optional",
      submit: "Submit Application",
      toast: {
        title: "Application submitted",
        description: "Thank you for your application! We'll be in touch soon."
      }
    },
    jobs: {
      customerSuccess: {
        title: "Customer Success & Onboarding Specialist",
        department: "Customer Success",
        location: "Remote",
        description: "Join our customer success team to help hospitality businesses successfully implement and get the most out of hostcall.ai. You'll be responsible for onboarding new customers, providing training, and ensuring their continued satisfaction with our platform.",
        requirements: [
          "2+ years of experience in customer success, onboarding, or account management",
          "Excellent communication and interpersonal skills",
          "Experience in the hospitality industry is a plus",
          "Problem-solving ability and attention to detail",
          "Ability to work in a fast-paced remote environment"
        ],
        responsibilities: [
          "Guide new customers through the onboarding process",
          "Provide product training and best practices",
          "Monitor customer success metrics and satisfaction",
          "Identify opportunities for customers to expand their use of our platform",
          "Collaborate with product and engineering teams to address customer needs"
        ]
      },
      salesEngineer: {
        title: "Sales Engineer",
        department: "Sales",
        location: "Remote",
        description: "As a Sales Engineer, you'll work closely with our sales team to provide technical expertise during the sales process. You'll help prospects understand the technical aspects of our product, demonstrate its capabilities, and address technical questions.",
        requirements: [
          "3+ years of experience in sales engineering or technical sales",
          "Strong technical knowledge and ability to explain complex concepts simply",
          "Experience with SaaS products and APIs",
          "Excellent presentation and demonstration skills",
          "Knowledge of the hospitality industry is a plus"
        ],
        responsibilities: [
          "Conduct technical product demonstrations for prospects",
          "Address technical questions during the sales process",
          "Support the sales team with technical expertise",
          "Gather technical requirements from prospects",
          "Collaborate with product and engineering teams on product feedback"
        ]
      },
      backendAiDeveloper: {
        title: "Backend and AI Developer",
        department: "Engineering",
        location: "Remote",
        description: "We're looking for a skilled Backend and AI Developer to help us build and improve our AI-powered hospitality platform. You'll work on developing and optimizing our backend systems and AI models that power our conversational AI agent.",
        requirements: [
          "5+ years of experience in backend development",
          "Experience with AI/ML technologies, particularly NLP and conversational AI",
          "Proficiency in Python, Node.js, or similar backend technologies",
          "Experience with cloud platforms (AWS, GCP, or Azure)",
          "Knowledge of RESTful APIs and microservices architecture"
        ],
        responsibilities: [
          "Develop and maintain our backend systems and API endpoints",
          "Work on AI model training, tuning, and deployment",
          "Improve the performance and accuracy of our conversational AI agent",
          "Implement integrations with hospitality management systems",
          "Collaborate with the product team to implement new features"
        ]
      }
    }
  },

  // Pricing page
  pricing: {
    title: "Simple, Transparent Pricing",
    subtitle: "Choose the plan that fits your needs and start transforming your guest communication today.",
    plans: {
      basic: {
        name: "Starter",
        price: "$299",
        description: "Perfect for small properties with up to 10 rooms",
        features: [
          "24/7 call handling",
          "Basic property integrations",
          "Pre-stay communications",
          "Post-stay feedback collection",
          "Email support",
          "5 languages supported"
        ]
      },
      pro: {
        name: "Professional",
        price: "$599",
        description: "Ideal for mid-sized properties with up to 50 rooms",
        features: [
          "Everything in Starter",
          "Advanced PMS integrations",
          "In-stay guest communication",
          "Custom voice and personality",
          "Analytics dashboard",
          "Priority support",
          "20 languages supported"
        ],
        popular: "Most Popular"
      },
      enterprise: {
        name: "Enterprise",
        price: "Custom",
        description: "Tailored solutions for large properties and hotel groups",
        features: [
          "Everything in Professional",
          "Unlimited rooms",
          "Full API access",
          "Custom integrations",
          "White-label option",
          "Dedicated account manager",
          "All languages supported"
        ]
      }
    },
    getStarted: "Get Started",
    contactSales: "Contact Sales",
    perMonth: "/month",
    callUs: "Not sure which plan is right for you?",
    callUsDesc: "Schedule a consultation with our hospitality experts to find the perfect solution for your property.",
    consultation: "Book Consultation"
  },

  pricingPage: {
    keyFeatures: {
      title: "Key Features",
      subtitle: "Explore the features that make hostcall.ai the ultimate guest communication solution."
    },
    choosePlan: {
      title: "Choose Your Plan",
      subtitle: "Select the pricing tier that best suits your property's needs."
    },
    cta: {
      title: "Ready to get started?",
      subtitle: "Start your free trial today and experience the future of guest communication."
    }
  },

  // Demo page
  demo: {
    hero: {
      title: "Experience hostcall.ai in Action",
      subtitle: "Schedule a personalized demo to see how our AI-powered guest communication platform can transform your property's operations."
    },
    form: {
      step1: {
        title: "Request Your Demo",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Work Email",
        phone: "Phone Number",
        company: "Company / Property Name",
        propertyType: "Property Type",
        roomCount: "Number of Rooms/Units",
        continue: "Continue to Schedule Demo",
        privacyNote: "By submitting this form, you agree to our"
      },
      step2: {
        title: "Schedule Your Demo",
        date: "Preferred Date",
        time: "Preferred Time",
        timezone: "Time Zone",
        requirements: "Specific Requirements or Questions",
        requirementsPlaceholder: "Let us know about any specific features you'd like to see or questions you have",
        timezoneNote: "All times are in your local timezone.",
        back: "Back",
        submit: "Schedule Demo",
        submitting: "Submitting..."
      },
      propertyTypes: {
        hotel: "Hotel",
        resort: "Resort",
        vacationRental: "Vacation Rental",
        apartment: "Serviced Apartment",
        bnb: "B&B / Inn",
        other: "Other"
      },
      roomCounts: {
        small: "1-10",
        medium: "11-50",
        large: "51-100",
        xlarge: "101-250",
        enterprise: "250+"
      }
    },
    success: {
      title: "Thank You!",
      message: "Your demo request has been submitted successfully. One of our team members will contact you shortly to confirm the details of your personalized demo session.",
      explore: "In the meantime, feel free to explore our resources to learn more about hostcall.ai.",
      watchVideo: "Watch Product Video",
      readCases: "Read Case Studies"
    },
    benefits: {
      title: "What You'll See in Your Demo",
      subtitle: "Our personalized demo sessions are tailored to your property's specific needs",
      platform: {
        title: "Platform Overview",
        description: "See the full capabilities of hostcall.ai and how it integrates with your existing systems."
      },
      custom: {
        title: "Custom Scenarios",
        description: "We'll demonstrate how hostcall.ai handles your property's specific guest communication needs."
      },
      implementation: {
        title: "Implementation Plan",
        description: "We'll discuss the setup process and create a timeline for getting your property started with hostcall.ai."
      }
    },
    testimonials: {
      title: "What Our Clients Say",
      subtitle: "Join hundreds of satisfied properties using hostcall.ai"
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Common questions about our demo process",
      questions: {
        duration: {
          q: "How long does the demo typically last?",
          a: "Our demos usually last 30-45 minutes, including time for your questions and discussion of your specific needs."
        },
        attendees: {
          q: "Who should attend the demo from our team?",
          a: "We recommend including decision-makers and operational team members who handle guest communications, such as front office managers, general managers, or property owners."
        },
        preparation: {
          q: "Is there any preparation needed before the demo?",
          a: "No special preparation is needed. However, having information about your current guest communication process and any specific challenges will help us tailor the demo to your needs."
        },
        trial: {
          q: "Can we get access to a trial version after the demo?",
          a: "Yes, we offer a 14-day free trial after the demo so you can experience hostcall.ai in your own environment. Our team will help you set everything up."
        }
      }
    },
    toast: {
      success: {
        title: "Demo Requested",
        description: "We've received your request and will contact you shortly to confirm your demo."
      },
      error: {
        title: "Error",
        description: "There was a problem submitting your request. Please try again."
      }
    }
  },

  // Legal pages
  legal: {
    privacy: {
      title: "Privacy Policy",
      lastUpdated: "Last updated: May 1, 2025",
      sections: {
        intro: {
          title: "1. Introduction",
          content: "At hostcall.ai, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our conversational AI services for the hospitality industry."
        },
        collection: {
          title: "2. Information We Collect",
          content: "We collect information that you provide directly to us, information we collect automatically when you use our services, and information from third-party sources.",
          personal: {
            title: "Personal Information",
            content: "This may include your name, email address, phone number, company information, and any other information you choose to provide."
          },
          usage: {
            title: "Usage Information",
            content: "We collect information about how you use our services, including log data, device information, location information, and cookies."
          }
        },
        use: {
          title: "3. How We Use Your Information",
          intro: "We use your information to:",
          items: [
            "Provide, maintain, and improve our services",
            "Develop new products and features",
            "Communicate with you about our services",
            "Monitor and analyze usage patterns",
            "Protect against fraudulent or unauthorized activity"
          ]
        },
        sharing: {
          title: "4. Data Sharing and Disclosure",
          content: "We may share your information with third-party service providers, business partners, and as required by law."
        },
        security: {
          title: "5. Security",
          content: "We implement appropriate technical and organizational measures to protect the security of your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure."
        },
        rights: {
          title: "6. Your Rights",
          content: "Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, or delete your personal information."
        },
        changes: {
          title: "7. Changes to This Policy",
          content: "We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page."
        },
        contact: {
          title: "8. Contact Us",
          content: "If you have any questions about this Privacy Policy, please contact us at"
        }
      }
    },
    terms: {
      title: "Terms of Service",
      lastUpdated: "Last updated: May 1, 2025",
      sections: {
        agreement: {
          title: "1. Agreement to Terms",
          content: "By accessing or using hostcall.ai, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site."
        },
        license: {
          title: "2. Use License",
          content: "Permission is granted to temporarily access the materials on hostcall.ai's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.",
          terminationIntro: "This license shall automatically terminate if you:",
          terminationItems: [
            "violate any of these restrictions",
            "terminate your subscription",
            "breach the agreement in any way"
          ]
        },
        disclaimer: {
          title: "3. Disclaimer",
          content: "The materials on hostcall.ai's website are provided on an 'as is' basis. hostcall.ai makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights."
        },
        limitations: {
          title: "4. Limitations",
          content: "In no event shall hostcall.ai or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on hostcall.ai's website, even if hostcall.ai or a hostcall.ai authorized representative has been notified orally or in writing of the possibility of such damage."
        },
        revisions: {
          title: "5. Revisions and Errata",
          content: "The materials appearing on hostcall.ai's website could include technical, typographical, or photographic errors. hostcall.ai does not warrant that any of the materials on its website are accurate, complete or current."
        },
        links: {
          title: "6. Links",
          content: "hostcall.ai has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by hostcall.ai of the site. Use of any such linked website is at the user's own risk."
        },
        governing: {
          title: "7. Governing Law",
          content: "These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts in that location."
        },
        contact: {
          title: "8. Contact Us",
          content: "If you have any questions about these Terms of Service, please contact us at"
        }
      }
    },
    cookies: {
      title: "Cookie Policy",
      lastUpdated: "Last updated: May 1, 2025",
      sections: {
        what: {
          title: "What are cookies?",
          content: "Cookies are small text files that are placed on your computer or mobile device when you browse websites. They are widely used to make websites work more efficiently and provide information to the website owners."
        },
        how: {
          title: "How we use cookies",
          intro: "hostcall.ai uses cookies for the following purposes:",
          items: {
            essential: {
              title: "Essential cookies:",
              content: "These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility."
            },
            analytics: {
              title: "Analytics cookies:",
              content: "These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously."
            },
            marketing: {
              title: "Marketing cookies:",
              content: "These cookies track your online activity to help advertisers deliver more relevant advertising or to limit how many times you see an ad."
            },
            preference: {
              title: "Preference cookies:",
              content: "These cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language."
            }
          }
        },
        types: {
          title: "Types of cookies we use",
          firstParty: {
            title: "First-party cookies",
            content: "These are cookies that are set by hostcall.ai directly. They are used to improve your user experience on our website."
          },
          thirdParty: {
            title: "Third-party cookies",
            content: "These are cookies set by other domains than hostcall.ai. They are used for various purposes including analytics, marketing, and social media integration."
          }
        },
        managing: {
          title: "Managing cookies",
          content: "Most web browsers allow some control of most cookies through the browser settings. To find out more about cookies, including how to see what cookies have been set, visit"
        },
        delete: {
          title: "How to delete and block cookies",
          content: "You can block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of our site."
        },
        changes: {
          title: "Changes to our cookie policy",
          content: "We may update our cookie policy from time to time. Any changes we make to our cookie policy in the future will be posted on this page."
        },
        contact: {
          title: "Contact us",
          content: "If you have any questions about our cookie policy, please contact us at"
        }
      }
    }
  },
  
  // FAQ section
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Get answers to common questions about our AI voice assistant",
    questions: [
      {
        q: "How does the AI voice assistant work?",
        a: "Our AI voice assistant uses advanced natural language processing to understand guest inquiries and respond appropriately. It integrates with your property management system to access booking information and can handle complex conversations about amenities, local recommendations, and guest services."
      },
      {
        q: "Can the AI handle multiple languages?",
        a: "Yes, our AI voice assistant supports over 20 languages and can automatically detect the caller's preferred language. This ensures international guests receive support in their native language, improving their experience."
      },
      {
        q: "How quickly can I set up the system?",
        a: "Setup typically takes 24-48 hours. We'll configure the AI with your property information, integrate with your existing systems, and provide training for your team. Most properties are operational within 2 business days."
      },
      {
        q: "What happens if the AI can't answer a question?",
        a: "The AI is designed to handle 90%+ of common guest inquiries. For complex issues it can't resolve, it seamlessly transfers the call to your staff with a summary of the conversation and guest's needs."
      },
      {
        q: "Is there a setup fee?",
        a: "No setup fees. We include onboarding, integration, and training in your monthly subscription. You only pay the monthly fee based on your chosen plan."
      },
      {
        q: "Can I customize the AI's personality and responses?",
        a: "Absolutely. You can customize the AI's voice, personality, tone, and responses to match your brand. We work with you during setup to ensure the AI represents your property perfectly."
      }
    ],
    moreQuestions: "Still have questions? We're here to help!",
    contactSupport: "Contact our support team",
    cta: {
      title: "Ready to transform your guest calling experience?",
      subtitle: "Join hundreds of properties already using hostcall.ai to provide exceptional guest experiences while reducing operational costs.",
      demoButton: "Request Free Demo",
      pricingButton: "View Pricing Plans",
      trial: "No credit card required • 14-day free trial available"
    }
  },

  // Blog page
  blog: {
    title: "Insights & Resources",
    subtitle: "Explore the latest trends, tips, and best practices for hospitality guest communication.",
    searchPlaceholder: "Search articles...",
    categories: {
      all: "All Posts",
      guestExperience: "Guest Experience",
      technology: "Technology",
      industryTrends: "Industry Trends",
      bestPractices: "Best Practices",
      caseStudies: "Case Studies",
      productUpdates: "Product Updates"
    },
    readTime: "min read",
    readMore: "Read More",
    noResults: {
      title: "No matching articles found",
      subtitle: "Try adjusting your search or browse all categories",
      showAll: "Show All Articles"
    },
    pagination: {
      previous: "Previous",
      next: "Next"
    },
    newsletter: {
      title: "Subscribe to Our Newsletter",
      subtitle: "Get the latest hospitality insights and updates delivered straight to your inbox.",
      placeholder: "Enter your email",
      button: "Subscribe"
    },
    roiSidebar: {
      title: "Calculate Your ROI",
      subtitle: "See how much you could save",
      avgSavings: "Average annual savings",
      payback: "Typical payback period",
      months: "months",
      cta: "Open Calculator",
      teaser: "Properties save avg. $45,000/year"
    },
    exitPopup: {
      title: "Wait! Don't leave yet",
      subtitle: "See how much your property could save with AI-powered guest communication",
      benefit1: "Calculate personalized ROI in 2 minutes",
      benefit2: "No credit card required",
      benefit3: "Get instant results",
      primaryCta: "Calculate My ROI",
      secondaryCta: "No thanks, I'll pass"
    }
  },

  // Blog Preview section
  blogPreview: {
    title: "Latest Insights & Resources",
    subtitle: "Stay updated with the latest trends and best practices in hospitality guest communication.",
    readMore: "Read More",
    viewAll: "View All Articles"
  },

  // Call to Action section
  cta: {
    title: "Revolutionize your guest communication today",
    subtitle: "Join hundreds of properties using HostCall.ai to provide exceptional guest experiences while saving time and resources.",
    button: "Request Demo",
    trial: "No credit card required. Free 14-day trial available."
  },

  // Vacation Rental Use Case section
  vacationRental: {
    badge: "Use Case",
    title: "Your Vacation Rental",
    subtitle: "See how HostCall.ai transforms guest communication for vacation rental owners, from pre-booking inquiries to post-checkout reviews.",
    benefits: {
      checkin: {
        title: "Automated Check-in Calls",
        description: "Guests receive personalized arrival instructions and property details automatically."
      },
      support: {
        title: "24/7 Guest Support",
        description: "Handle inquiries about amenities, WiFi, and house rules any time of day."
      },
      booking: {
        title: "Booking Confirmations",
        description: "Instant confirmation calls and reminders reduce no-shows significantly."
      },
      local: {
        title: "Local Recommendations",
        description: "AI provides personalized tips for restaurants, activities, and attractions."
      }
    },
    cta: "Schedule Custom Demo"
  },

  // Integrations section
  integrations: {
    title: "Powerful Integrations",
    subtitle: "Configure your Hostcall.ai account to automate a variety of tasks and actions using 1-click integrations",
    cards: {
      make: {
        title: "Make",
        description: "Connect Hostcall.ai with 1,000+ apps using Make.com to automate voice calls, contact syncing, and real-time workflows—no code needed."
      },
      twilio: {
        title: "Twilio",
        description: "Fully embedded into Hostcall's infrastructure for provisioning branded phone numbers, handling SMS, and powering scalable voice communication."
      },
      whatsapp: {
        title: "WhatsApp",
        description: "Enables enhanced automation and conversational flows via WhatsApp Business, integrated seamlessly into your Hostcall-powered infrastructure."
      },
      googleCalendar: {
        title: "Google Calendar",
        description: "Easily connect Hostcall.ai with your Google Calendar to enable real-time appointment scheduling, confirmations, and rescheduling during AI calls."
      },
      zapier: {
        title: "Zapier",
        description: "Automatically trigger AI calls, update contact records, send follow-ups, and sync data across your stack without writing a single line of code."
      },
      apis: {
        title: "APIs & Webhooks",
        description: "Connect with custom systems and services through our robust API and webhook infrastructure for unlimited integration possibilities."
      }
    },
    cta: {
      title: "Connect Hostcall to 6,000+ apps",
      subtitle: "Effortlessly connect Hostcall with apps like Mailchimp, GoHighLevel, Google forms, Calendly, Wix, Webflow and many more using Zapier, Make, APIs & Webhooks.",
      optimize: "Optimize Workflows:",
      optimizeDesc: "Leverage the magic of integration to optimize your workflows and attain unparalleled efficiency and manage outreach campaigns tailored to your business.",
      button: "Schedule a Demo",
      trial: "14-day Free Trial",
      credit: "Free $10 Credit"
    },
    customIntegration: "Request Custom Integration"
  },

  // Analytics Reporting section
  analytics: {
    title: "Analytics & Reporting",
    subtitle: "Turn conversations into actionable insights with our comprehensive analytics and reporting tools.",
    callAnalytics: "Call Analytics",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    responseRate: "Response Rate",
    recentConversation: "Recent Conversation",
    viewAll: "View All",
    incoming: "Incoming",
    positiveSentiment: "Positive Sentiment",
    callDuration: "Call Duration",
    export: "Export",
    performanceMetrics: {
      title: "Performance Metrics",
      subtitle: "Track call volumes, engagement rates, and conversion metrics in real-time.",
      advancedAnalytics: "Advanced Analytics",
      advancedAnalyticsDesc: "Interactive dashboards for deeper insights",
      avgResponse: "Avg. Response",
      callsMonth: "Calls/Month",
      avgDuration: "Avg Duration"
    },
    transcripts: {
      title: "Transcripts & Recordings",
      subtitle: "Access accurate transcripts and high-quality call recordings for every conversation.",
      sentimentAnalysis: "Sentiment Analysis",
      sentimentAnalysisDesc: "Understand customer emotions and intent",
      breakdown: "Sentiment Breakdown",
      last30Days: "Last 30 days",
      positive: "Positive",
      neutral: "Neutral",
      negative: "Negative"
    },
    cta: "Schedule a Demo",
    trial: "14-day Free Trial",
    credit: "Free $10 Credit"
  },

  // Campaign Manager section
  campaignManager: {
    title: "Outreach Campaign Manager",
    subtitle: "Manage and automate your outreach campaigns with precision. Create personalized guest communication flows that drive engagement and bookings.",
    features: {
      messaging: {
        title: "Personalized Messaging",
        description: "Craft unique messages tailored to each guest, ensuring a personal touch that enhances their experience."
      },
      scheduling: {
        title: "Automated Scheduling",
        description: "Schedule messages to be sent at optimal times, maximizing engagement and ensuring timely communication."
      },
      multichannel: {
        title: "Multi-Channel Support",
        description: "Reach guests on their preferred platforms, whether it's SMS, email, or in-app messaging, for seamless communication."
      }
    },
    dashboard: {
      title: "Dashboard Overview",
      activeCampaigns: "Active Campaigns",
      totalResults: "Total Results",
      responseRate: "Response Rate",
      fromLastMonth: "from last month",
      recentActivity: "Recent Activity",
      newBooking: "New booking confirmed",
      guestResponded: "Guest responded",
      messageDelivered: "Message delivered"
    },
    analytics: {
      title: "Analytics",
      responseRate: "Response Rate",
      campaignPerformance: "Campaign Performance",
      channels: "Channels"
    },
    campaigns: {
      title: "Campaigns",
      newCampaign: "New Campaign",
      searchPlaceholder: "Search campaigns...",
      filter: "Filter",
      sort: "Sort",
      status: "Status",
      campaign: "Campaign",
      agent: "Agent",
      noAnswer: "No Answer",
      results: "Results",
      amountSpent: "Amount Spent",
      costPerResult: "Cost Per Result",
      actions: "Actions",
      live: "Live"
    },
    sidebar: {
      dashboard: "Dashboard",
      campaigns: "Campaigns",
      analytics: "Analytics",
      contacts: "Contacts",
      settings: "Settings"
    },
    cta: "Schedule a Demo",
    trial: "14-day Free Trial",
    credit: "Free $10 Credit"
  },

  // Feature page
  featurePage: {
    hero: {
      title: "Complete AI-Powered Automated Call Suite",
      subtitle: "Discover how hostcall.ai's intelligent calling system automates personalized communications at every stage of the guest journey.",
      demoButton: "Request Demo"
    },
    featureGroups: [
      {
        title: "Pre-Stay Automated Calls",
        description: "Engage guests before arrival with automated welcome calls that prepare them for an exceptional stay.",
        features: [
          "Automated booking confirmation calls",
          "Pre-arrival information and FAQ calls",
          "Special request collection via phone",
          "Automated check-in instruction calls",
          "Proactive upsell calls for room upgrades",
          "Transportation coordination calls"
        ]
      },
      {
        title: "In-Stay Automated Calls",
        description: "Deliver instant assistance during the guest stay with AI-powered outbound and inbound calls.",
        features: [
          "24/7 automated guest inquiry calls",
          "Outbound local recommendation calls",
          "Automated room service call handling",
          "Issue resolution through automated calls",
          "Amenity information via scheduled calls",
          "Extension requests through AI phone system"
        ]
      },
      {
        title: "Post-Stay Automated Calls",
        description: "Maintain guest relationships after checkout through timely, personalized follow-up calls.",
        features: [
          "Automated checkout confirmation calls",
          "Satisfaction survey calls",
          "Review request automated calls",
          "Future booking incentive calls",
          "Loyalty program engagement calls",
          "Personalized anniversary and special occasion calls"
        ]
      },
      {
        title: "Multilingual Call Support",
        description: "Break language barriers with AI-powered communication in your guests' preferred languages.",
        features: [
          "Automated calls in 20+ languages",
          "Dialect and accent recognition during calls",
          "Culturally appropriate voice responses",
          "Language preference tracking for future calls",
          "Context-aware translations in phone conversations",
          "Specialized hospitality terminology in all languages"
        ]
      },
      {
        title: "Call System Integration",
        description: "Connect our automated calling system seamlessly with your existing systems for unified operations.",
        features: [
          "PMS integration for automated call data (Opera, Mews, etc.)",
          "CRM synchronization for personalized call experiences",
          "Channel manager compatibility for booking-related calls",
          "Call analytics and reporting tools",
          "Automated task creation from call content",
          "Payment processing mentions during calls"
        ]
      },
      {
        title: "Call Analytics & Insights",
        description: "Gain valuable data from every automated guest call to continuously improve your service.",
        features: [
          "Automated call analytics and trends",
          "Guest satisfaction metrics from calls",
          "Common request tracking through call transcripts",
          "Staff efficiency improvements through call analysis",
          "Revenue opportunity identification from recorded calls",
          "Customizable call reporting dashboard"
        ]
      }
    ],
    cta: {
      title: "Ready to transform your guest calling experience?",
      subtitle: "Join hundreds of properties using hostcall.ai's automated calling system to provide exceptional communication throughout the guest journey.",
      demo: "Request Demo",
      pricing: "View Pricing"
    }
  },

  // Blog Post page
  blogPost: {
    notFound: {
      title: "Blog Post Not Found",
      message: "Sorry, the blog post you're looking for doesn't exist.",
      backButton: "Back to Blog"
    },
    backToArticles: "Back to all articles",
    minRead: "min read",
    cta: {
      title: "Ready to transform your guest experience?",
      description: "Join hundreds of hospitality businesses elevating their guest communication with hostcall.ai. Start your journey to exceptional guest experiences today.",
      requestDemo: "Request Demo",
      contactSales: "Contact Sales",
      interactive: "Interactive Tool"
    },
    roiCta: {
      title: "Calculate Your ROI",
      description: "See how much your property could save with AI-powered guest communication. Our interactive calculator shows your personalized ROI in under 2 minutes.",
      button: "Open ROI Calculator"
    },
    relatedArticles: "Related Articles",
    readMore: "Read More",
    newsletter: {
      title: "Stay Updated with Industry Insights",
      subtitle: "Join our newsletter and get the latest hospitality trends and tips delivered to your inbox.",
      placeholder: "Enter your email",
      button: "Subscribe"
    }
  },


  // 404 Not Found Page
  notFound: {
    title: "404",
    heading: "Page Not Found",
    message: "We're sorry, the page you requested could not be found. Please check the URL or navigate back to the homepage.",
    button: "Return to Homepage"
  },

  // SEO Meta Tags - Optimized for hospitality managers, hotel managers, CTOs
  seo: {
    siteName: "HostCall.ai",
    titleSuffix: " | HostCall.ai",
    
    home: {
      title: "AI Guest Communication for Hotels & Rentals | HostCall.ai",
      description: "Never miss a booking again. HostCall.ai handles unlimited guest calls 24/7 in 20+ languages. Trusted by 200+ hospitality properties. Start your free demo today.",
      keywords: "AI guest communication, hotel automation, vacation rental AI, hospitality technology, 24/7 guest support, multilingual hotel software, hotel CTO solutions"
    },
    
    features: {
      title: "AI Voice Agent Features for Hospitality | HostCall.ai",
      description: "24/7 call handling, 20+ languages, PMS integration, real-time analytics. See how HostCall.ai transforms guest communication for hotels and rentals.",
      keywords: "hotel AI features, voice AI hospitality, PMS integration, guest communication automation, hotel technology CTO"
    },
    
    pricing: {
      title: "Simple, Transparent Pricing for Hotels | HostCall.ai",
      description: "Flexible pricing plans for properties of all sizes. From boutique hotels to enterprise chains. No hidden fees. Start with a free demo.",
      keywords: "hotel AI pricing, hospitality software cost, vacation rental automation pricing, hotel manager budget"
    },
    
    about: {
      title: "About HostCall.ai - Transforming Hospitality Communication",
      description: "Founded by hospitality veterans and AI experts. Learn how HostCall.ai is revolutionizing guest communication for 200+ properties worldwide.",
      keywords: "HostCall.ai company, hospitality AI startup, hotel technology company, AI guest service"
    },
    
    contact: {
      title: "Contact Our Hospitality AI Experts | HostCall.ai",
      description: "Get in touch with our team. Request a demo, ask questions, or explore partnership opportunities. We respond within 24 hours.",
      keywords: "contact HostCall.ai, hospitality AI demo, hotel software consultation, speak with sales"
    },
    
    demo: {
      title: "Request Your Free Demo - See HostCall.ai in Action",
      description: "Schedule a personalized demo and see how HostCall.ai can increase your bookings by 35%. Free consultation with our hospitality AI experts.",
      keywords: "HostCall.ai demo, hotel AI demonstration, free hospitality software trial, book demo"
    },
    
    blog: {
      title: "Hospitality Industry Insights & AI Trends | HostCall.ai Blog",
      description: "Expert articles on AI in hospitality, guest communication strategies, and hotel technology trends. Stay ahead with HostCall.ai.",
      keywords: "hospitality blog, hotel AI trends, guest communication tips, hospitality manager insights"
    },
    
    careers: {
      title: "Join Our Team - Careers at HostCall.ai",
      description: "Help us transform the hospitality industry. Remote-first team, competitive benefits, meaningful work. View open positions.",
      keywords: "HostCall.ai careers, hospitality tech jobs, AI startup jobs, remote work hospitality"
    },
    
    businessCases: {
      title: "Hotel AI Booking Systems Case Studies | HostCall.ai",
      description: "Real hotel AI booking systems case studies: +37% direct bookings, 22 hrs/week saved, $142k extra revenue. See ROI from HostCall.ai customers.",
      keywords: "hotel ai booking systems case studies, hotel AI case studies, AI booking system ROI, hospitality success stories, vacation rental automation results"
    },
    
    notFound: {
      title: "Page Not Found | HostCall.ai",
      description: "The page you're looking for doesn't exist. Return to HostCall.ai homepage to explore AI-powered guest communication solutions."
    },
    
    apiDocs: {
      title: "API Documentation - Integrate HostCall.ai | Developer Guide",
      description: "Complete REST API documentation for HostCall.ai. Integrate AI voice agents into your hotel PMS, booking system, or property management software.",
      keywords: "HostCall.ai API, hotel API integration, hospitality developer docs, voice AI API, PMS integration API"
    },
    
    faq: {
      title: "FAQ - Common Questions About HostCall.ai",
      description: "Find answers to frequently asked questions about HostCall.ai's AI voice assistant for hotels and vacation rentals.",
      keywords: "HostCall.ai FAQ, AI assistant questions, hospitality AI help"
    }
  },

  // API Documentation
  apiDocs: {
    pageTitle: "Hostcall.ai API Documentation",
    pageSubtitle: "Integrate our powerful hospitality AI voice agents directly into your systems with our comprehensive REST API.",
    
    nav: {
      title: "API Documentation",
      gettingStarted: "Getting Started",
      authentication: "Authentication",
      apiReference: "API Reference",
      endpoints: "Endpoints",
      errorCodes: "Error Codes",
      rateLimits: "Rate Limits",
      examples: "Examples"
    },
    
    gettingStarted: {
      title: "Getting Started",
      baseUrl: "Base URL",
      baseUrlDescription: "All API requests should be made to the base URL above. HTTPS is required for all API requests.",
      requestFormat: "Request Format",
      requestFormatDescription: "Our API accepts form-encoded request bodies, JSON request bodies, and supports path parameters. The documentation for each endpoint will specify the expected format."
    },
    
    authentication: {
      title: "Authentication",
      apiKeys: "API Keys",
      apiKeysDescription: "Authentication is performed with API keys. Each API request requires either an Account API key or a Project API key.",
      authHeader: "Authentication Header",
      securityWarning: "Keep your API keys secure! Never share them in publicly accessible areas such as GitHub or client-side code.",
      keyTypes: "Key Types",
      accountKey: "Account API Key",
      accountKeyDesc: "Used for managing account-level resources and obtaining usage information.",
      projectKey: "Project API Key",
      projectKeyDesc: "Used for project-specific operations like creating and managing calls.",
      exampleRequest: "Example Authentication Request"
    },
    
    apiReference: {
      title: "API Reference",
      resources: "Resources",
      resourcesDescription: "The API is organized around the following resources:",
      projects: "Projects",
      projectsDesc: "Manage projects within your account",
      agents: "Agents",
      agentsDesc: "Configure and manage AI voice agents",
      calls: "Calls",
      callsDesc: "Create and manage outbound calls",
      webhooks: "Webhooks",
      webhooksDesc: "Set up endpoints to receive real-time updates"
    },
    
    endpoints: {
      title: "Endpoints",
      projects: "Projects",
      agents: "Agents",
      calls: "Calls",
      webhooks: "Webhooks",
      listProjects: "List all projects in your account.",
      getProject: "Retrieve information about a specific project.",
      listAgents: "List all available voice agents for a specific project.",
      createAgent: "Create a new voice agent for a project.",
      createCall: "Create a new outbound call using a voice agent.",
      getCall: "Retrieve information about a specific call.",
      createWebhook: "Create a new webhook endpoint to receive real-time updates about calls.",
      pathParameters: "Path Parameters",
      requestBody: "Request Body",
      response: "Response"
    },
    
    errorCodes: {
      title: "Error Codes",
      description: "The Hostcall.ai API uses conventional HTTP response codes to indicate the success or failure of an API request:",
      code: "Code",
      codeDescription: "Description",
      responseFormat: "Error Response Format",
      codes: {
        ok: "Everything worked as expected",
        badRequest: "The request was unacceptable, often due to missing a required parameter",
        unauthorized: "No valid API key provided",
        forbidden: "The API key doesn't have permissions to perform the request",
        notFound: "The requested resource doesn't exist",
        tooManyRequests: "Too many requests hit the API too quickly",
        serverErrors: "Something went wrong on Hostcall.ai's end"
      }
    },
    
    rateLimits: {
      title: "Rate Limits",
      description: "The API implements rate limiting to ensure stability and fair usage. Limits vary by endpoint and plan:",
      plan: "Plan",
      endpoint: "Endpoint",
      rateLimit: "Rate Limit",
      otherEndpoints: "Other endpoints",
      requestsPerMinute: "requests/minute",
      headersDescription: "Rate limit headers are included in all API responses:"
    },
    
    examples: {
      title: "Code Examples",
      reservationCall: "Creating an Outbound Reservation Confirmation Call"
    },
    
    cta: {
      title: "Ready to get started?",
      subtitle: "Create your account and get your API keys.",
      button: "Sign Up for API Access"
    }
  },
  
  // FAQ Page (dedicated page)
  faqPage: {
    hero: {
      title: "Frequently Asked Questions",
      subtitle: "Find answers to common questions about HostCall.ai's AI-powered guest communication platform.",
      searchPlaceholder: "Search for answers..."
    },
    filter: {
      all: "All Questions",
      general: "General",
      pricing: "Pricing & Plans",
      technical: "Technical",
      setup: "Setup & Onboarding",
      privacy: "Privacy & Security"
    },
    noResults: "No questions found matching your search.",
    clearFilters: "Clear Filters",
    categories: {
      general: {
        title: "General Questions",
        questions: [
          {
            q: "What is HostCall.ai?",
            a: "HostCall.ai is an AI-powered voice assistant platform designed specifically for the hospitality industry. It handles guest calls 24/7, answers questions about bookings, amenities, and local recommendations, and integrates seamlessly with your existing property management systems."
          },
          {
            q: "How does the AI voice assistant work?",
            a: "Our AI uses advanced natural language processing to understand guest inquiries and respond appropriately. It integrates with your property management system to access booking information and can handle complex conversations about amenities, local recommendations, and guest services."
          },
          {
            q: "Can the AI handle multiple languages?",
            a: "Yes, our AI voice assistant supports over 20 languages and can automatically detect the caller's preferred language. This ensures international guests receive support in their native language, improving their experience."
          },
          {
            q: "What types of properties can use HostCall.ai?",
            a: "HostCall.ai is designed for hotels of all sizes, vacation rentals, boutique properties, resort chains, and property management companies. Our platform scales from single properties to large portfolios with hundreds of units."
          },
          {
            q: "Can I customize the AI's personality and responses?",
            a: "Absolutely. You can customize the AI's voice, personality, tone, and responses to match your brand. We work with you during setup to ensure the AI represents your property perfectly."
          },
          {
            q: "What happens if the AI can't answer a question?",
            a: "The AI is designed to handle 90%+ of common guest inquiries. For complex issues it can't resolve, it seamlessly transfers the call to your staff with a summary of the conversation and guest's needs."
          }
        ]
      },
      pricing: {
        title: "Pricing & Plans",
        questions: [
          {
            q: "Is there a setup fee?",
            a: "No setup fees. We include onboarding, integration, and training in your monthly subscription. You only pay the monthly fee based on your chosen plan."
          },
          {
            q: "Do you offer a free trial?",
            a: "Yes! We offer a 14-day free trial with full access to all features. No credit card required to start. You can experience the full power of HostCall.ai before making any commitment."
          },
          {
            q: "What payment methods do you accept?",
            a: "We accept all major credit cards (Visa, Mastercard, American Express), bank transfers, and can set up invoicing for Enterprise clients with annual contracts."
          },
          {
            q: "Can I upgrade or downgrade my plan?",
            a: "Yes, you can change your plan at any time. Upgrades take effect immediately, and downgrades apply at the end of your current billing cycle. No penalties or hidden fees."
          },
          {
            q: "Do you offer discounts for annual billing?",
            a: "Yes, we offer significant discounts for annual commitments. Contact our sales team to discuss annual pricing and custom enterprise agreements."
          }
        ]
      },
      technical: {
        title: "Technical & Integrations",
        questions: [
          {
            q: "Which property management systems do you integrate with?",
            a: "We support all major PMS platforms including Opera, Mews, Cloudbeds, Guesty, Hostaway, and many others. We also offer a robust API for custom integrations."
          },
          {
            q: "Do you integrate with booking platforms?",
            a: "Yes, HostCall.ai integrates with major OTAs and booking platforms including Airbnb, Booking.com, Vrbo, Expedia, and direct booking engines."
          },
          {
            q: "Is there an API available?",
            a: "Yes, we provide a comprehensive REST API for developers who want to build custom integrations. Our API documentation includes examples in multiple programming languages."
          },
          {
            q: "How secure is my data?",
            a: "We take security seriously. All data is encrypted in transit and at rest. We're SOC 2 compliant and follow GDPR guidelines. We never share your data with third parties."
          },
          {
            q: "Can I use my existing phone numbers?",
            a: "Yes, you can port your existing phone numbers to HostCall.ai or use new numbers we provision for you. We support local numbers in 50+ countries."
          }
        ]
      },
      setup: {
        title: "Setup & Onboarding",
        questions: [
          {
            q: "How quickly can I set up the system?",
            a: "Setup typically takes 24-48 hours. We'll configure the AI with your property information, integrate with your existing systems, and provide training for your team. Most properties are operational within 2 business days."
          },
          {
            q: "Do you provide training?",
            a: "Yes, all plans include comprehensive onboarding and training. Our customer success team will guide you through setup, show you how to use the dashboard, and ensure your team is comfortable with the system."
          },
          {
            q: "Can I add more properties later?",
            a: "Absolutely. You can add new properties at any time through your dashboard. Each property can have its own customized AI configuration while sharing a central management interface."
          },
          {
            q: "What information do you need from me to get started?",
            a: "We'll need basic property information, your PMS credentials for integration, and your preferred AI personality settings. Our onboarding team will guide you through collecting everything needed."
          }
        ]
      },
      privacy: {
        title: "Privacy & Security",
        questions: [
          {
            q: "How do you handle guest data?",
            a: "Guest data is processed in compliance with GDPR and other privacy regulations. We only store data necessary for service delivery, and you can request data deletion at any time."
          },
          {
            q: "Are calls recorded?",
            a: "Call recording is optional and can be enabled/disabled per your preference. If enabled, recordings are stored securely and can be used for quality assurance and training purposes."
          },
          {
            q: "Where is data stored?",
            a: "Data is stored in secure, SOC 2 compliant data centers. European customers' data is stored in EU data centers to comply with GDPR data residency requirements."
          },
          {
            q: "Can guests opt out of AI calls?",
            a: "Yes, guests can always request to speak with a human. The AI will seamlessly transfer the call to your staff if requested, ensuring guests always have the option for human interaction."
          }
        ]
      }
    },
    contact: {
      title: "Still have questions?",
      subtitle: "Our team is here to help. Reach out through any of these channels.",
      chat: {
        title: "Live Chat",
        description: "Chat with our support team in real-time.",
        button: "Start Chat"
      },
      email: {
        title: "Email Support",
        description: "We'll respond within 24 hours.",
        button: "Send Email"
      },
      phone: {
        title: "Phone Support",
        description: "Talk to a real person.",
        button: "Call Us"
      }
    },
    cta: {
      title: "Ready to transform your guest communication?",
      subtitle: "Join hundreds of properties already using HostCall.ai to provide exceptional guest experiences.",
      demoButton: "Request Free Demo",
      contactButton: "Contact Sales"
    }
  },

  // ROI Wizard
  roiWizard: {
    title: "ROI Calculator",
    quickMode: "Quick Calculate",
    fullMode: "Full Analysis",
    steps: {
      basics: { title: "Business Basics", subtitle: "Tell us about your operation" },
      revenue: { title: "Revenue Impact", subtitle: "Understand missed call costs" },
      costs: { title: "Cost Analysis", subtitle: "Current staff expenses" },
      results: { title: "Your Results", subtitle: "See your potential savings" },
      actions: { title: "Take Action", subtitle: "Start saving today" }
    },
    labels: {
      callsPerMonth: "Calls per Month",
      properties: "Number of Properties",
      missedPercent: "Missed Call %",
      salesPercent: "Sales Calls %",
      avgOrder: "Avg Stay Value",
      staffHours: "Staff Hours/Week for Guest Communication",
      hourlyCost: "Hourly Staff Cost",
      howWeCalc: "How we calculate"
    },
    results: {
      totalAnnual: "Total Annual Impact",
      revenueLost: "Revenue Lost",
      promoterImpact: "Promoter Impact",
      costSavings: "Cost Savings",
      paybackPeriod: "Payback Period",
      months: "months",
      yearOneROI: "Year 1 ROI",
      breakEven: "Break-even by",
      perYear: "per year"
    },
    promoter: {
      title: "Missed Promoter Impact",
      description: "Poor support = dissatisfied guests = no word-of-mouth. With {count} lost promoters monthly."
    },
    costs: {
      currentCost: "Current Cost",
      withHostcall: "With HostCall.ai"
    },
    chart: {
      title: "12-Month Impact",
      without: "Without",
      with: "With"
    },
    comparison: {
      title: "Industry Comparison",
      you: "You",
      industryAvg: "Industry Avg",
      top25: "Top 25%",
      yourRoi: "Your ROI",
      elitePerformer: "Elite Performer",
      aboveAverage: "Above Average",
      topPerformer: "Top Performer!"
    },
    scenarios: {
      saveScenario: "Save Scenario",
      compare: "Compare",
      savedScenarios: "Saved Scenarios",
      noScenarios: "No saved scenarios yet",
      loadScenario: "Load",
      deleteScenario: "Delete"
    },
    actions: {
      next: "Next",
      back: "Back",
      done: "Done",
      getReport: "Get Your Full Report",
      downloadPdf: "Download PDF Report",
      emailReport: "Email Your Report",
      bookDemo: "Book a Demo",
      freeTrial: "Start Free Trial",
      send: "Send",
      download: "Download",
      startNow: "Start Now"
    },
    quick: {
      title: "Quick ROI Estimate",
      subtitle: "3 inputs, instant results",
      annualSavings: "Estimated Annual Savings",
      payback: "Payback",
      roi: "Year 1 ROI",
      getDetailed: "Get Detailed Analysis",
      disclaimer: "* Using industry averages: 40% missed calls, 20% sales calls, $25/hr staff"
    },
    email: {
      getDetailedPdf: "Get a detailed PDF report",
      nameOptional: "Name (optional)",
      reportSent: "Report sent! Check your inbox.",
      shareWithTeam: "Share with your team"
    },
    cta: {
      startSavingToday: "Start Saving Today!",
      takeNextStep: "Take the next step to capture every call",
      seeInAction: "See HostCall.ai in action",
      daysFreeTrial: "14 days free, no card required"
    },
    celebration: {
      fastPayback: "Amazing! Less than 3 months payback!"
    }
  },
  
  // Follow modal
  followModal: {
    neverMiss: "Never miss a story from",
    subtitle: "Sign up to see stories from {authorName} and thousands of other writers on HostCall.ai.",
    signUpGoogle: "Sign up with Google",
    signUpEmail: "Sign up with email",
    alreadyHaveAccount: "Already have an account?",
    signIn: "Sign in"
  },
  
  // Admin
  admin: {
    responses: {
      title: "Responses",
      description: "Manage and moderate user comments across all articles.",
      columns: {
        article: "Article",
        commenter: "Commenter",
        content: "Content",
        date: "Date",
        status: "Status",
        actions: "Actions"
      },
      status: {
        all: "All",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        spam: "Spam"
      },
      actions: {
        approve: "Approve",
        reject: "Reject",
        markSpam: "Mark as Spam",
        delete: "Delete"
      },
      empty: "No comments yet"
    },
    followers: {
      title: "Followers",
      description: "View all users following blog authors.",
      totalFollowers: "Total Followers",
      columns: {
        follower: "Follower",
        email: "Email",
        following: "Following",
        since: "Since"
      },
      exportCsv: "Export CSV",
      empty: "No followers yet"
    }
  }
};